import script from "./ScrollTemplate.vue?vue&type=script&setup=true&lang=js"
export * from "./ScrollTemplate.vue?vue&type=script&setup=true&lang=js"

const cssModules = {}
import style0 from "./ScrollTemplate.vue?vue&type=style&index=0&id=7d8cc660&scoped=true&lang=scss&module=true"
cssModules["$style"] = style0

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__cssModules',cssModules],['__scopeId',"data-v-7d8cc660"]])

export default __exports__